import React from 'react';
import { Routes, Route, HashRouter } from "react-router-dom";
import { Part1 } from './pages/Part1.tsx';
import { HomePage } from './pages/Home.tsx';

function App() {
  React.useEffect(() => {
    document.title = "Playground DB"
  }, []);

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/1" element={<Part1 />} />
      </Routes>
    </HashRouter>
  );
}


export default App;
